import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { User } from '../types';

export async function getUsers(): Promise<User[]> {
  return apiGet<User[]>('/users');
}

export async function getUser(id: string): Promise<User> {
  return apiGet<User>(`/users/${id}`);
}

export async function createUser(data: {
  name: string;
  email: string;
  password: string;
  role: string;
  companyId?: string;
  departmentId?: string;
}): Promise<User> {
  return apiPost<User>('/users', data);
}

export async function updateUser(id: string, data: {
  name?: string;
  email?: string;
  password?: string;
  role?: string;
  departmentId?: string;
  isActive?: boolean;
}): Promise<User> {
  return apiPatch<User>(`/users/${id}`, data);
}

export async function deleteUser(id: string): Promise<void> {
  return apiDelete<void>(`/users/${id}`);
}
